import { useDispatch, useSelector } from "react-redux";
import MainSideColumn from "../../Components/sidebars/MainSideColumn";
import ChildSideColumn from "../../Components/sidebars/ChildSideColumn";
import "../products/product.scss";
import { hide, setActiveIndex } from "../../redux/SideBarSlice";
import { DIRECT_CARDS, SERVICES } from "./constant";
import RightContentColumn from "../../Components/sidebars/RightContentColumn ";

const Services = () => {
  const visible = useSelector((state) => state.sidebarItem.visible);
  const source = useSelector((state) => state.sidebarItem.source);
  console.log("Redux state:", { visible, source });

  const activeIndex = useSelector((state) => state.sidebarItem.activeIndex);
  const suppressHighlight = useSelector(
    (state) => state.sidebarItem.suppressHighlight,
  );
  const dispatch = useDispatch();

  const getActiveCards = () => {
    if (activeIndex === null) return DIRECT_CARDS;
    const activeItem = SERVICES[activeIndex];
    if (!activeItem) return [];

    // Item with segments → use that item's cards; direct link (no segments) → use DIRECT_CARDS
    const hasSegments = activeItem.segments?.length > 0;
    return hasSegments ? activeItem.cards || DIRECT_CARDS : DIRECT_CARDS;
  };

  function handleProductClick(index) {
    dispatch(setActiveIndex(index));

    if (index === 0 || index === 4 || index === 5) {
      dispatch(hide());
    }
  }

  const state = useSelector((state) => state.sidebarItem);
  console.log("Current state:", state);

  return (
    <>
      {visible && source === "services" && (
        <div className="product-container">
          {/* Main Products Column */}
          <MainSideColumn
            products={SERVICES}
            activeIndex={activeIndex}
            suppressHighlight={suppressHighlight}
            onProductClick={handleProductClick}
            title="Services"
          />

          {activeIndex !== null && !suppressHighlight && (
            <>
              {/* Segment Column - only when user has selected an item */}
              {SERVICES[activeIndex]?.segments?.length > 0 && (
                <ChildSideColumn
                  className="software-column"
                  title="Segments"
                  items={SERVICES[activeIndex].segments.map(
                    (segment) => segment,
                  )}
                />
              )}
            </>
          )}

          {/* RIGHT – Cards */}
          <RightContentColumn
            cards={getActiveCards()}
            limit={
              activeIndex !== null &&
              !suppressHighlight &&
              SERVICES[activeIndex]?.segments?.length > 0
                ? 4
                : null
            }
          />
        </div>
      )}
    </>
  );
};

export default Services;
